import _ from 'lodash';

const isVisible = (viewModel, path, defaultValue) => _.get(viewModel, `${path}.aspects.ocular`, defaultValue);

const getMetaDataMapAvailableValues = (viewModel, path, mapper, defaultValue) => {
    const metaDataMap = viewModel?.metaDataMap?.value;
    const propMap = metaDataMap?.find(metadata => metadata?.propName === path);
    const availableValues = propMap?.availableValues;

    return (mapper ? availableValues?.map(mapper) : availableValues) ?? defaultValue;
};

export default {
    isVisible,
    getMetaDataMapAvailableValues,
};
